// Hidden-variant sprite overrides (the kids' /hidden build). These replace specific enemy
// textures by key; every char must exist in the shared PAL (see pixelArt.ts). Merged over
// the base SPRITES only when VARIANT === 'hidden', so the base game's art is untouched.
// Keys not present here fall through to the base sprite (e.g. spore, bosses, player, fx).

// prettier-ignore
export const SPRITES_HIDDEN: Record<string, string[]> = {
  // Slime Plop: a round leafy bush with a little trunk (tree-like slime).
  slime: [
    '..oooo..',
    '.oggggo.',
    'oggggggo',
    'ogwggwgo',
    'oggggggo',
    '.oGGGGo.',
    '..oAAo..',
    '..oAAo..',
  ],
  // Grass Sharp: spiky green grass blades with eyes (was Glass Shard).
  glass: [
    'g.g.g.g.',
    'g.g.g.g.',
    'gGgGgGgG',
    'oGGGGGGo',
    'oGwGGwGo',
    'oGGGGGGo',
    '.oGGGGo.',
    '..oooo..',
  ],
  // Ink Raid: a little cluster of dark ink droplets (was the Ink Wraith ghost).
  wraith: [
    '.p...p..',
    '.p...p..',
    'pPp.pPp.',
    'PPP.PPP.',
    '.P...P..',
    '..pPp...',
    '..PPP...',
    '...P....',
  ],
  // Bloated TVA: the vat with a big money $ on its belly.
  vat: [
    '.ooooooo.',
    'oNNwwwNNo',
    'oNNwwNNNo',
    'oNNwwwNNo',
    'oNNNwwNNo',
    'oNNwwwNNo',
    'oNNNwNNNo',
    'oNNNNNNNo',
    '.ooooooo.',
  ],
  // Mortar Mort: a green zombie face with hollow eyes + teeth.
  mortar: [
    '..oooo..',
    '.oLLLLo.',
    'oLllllLo',
    'oLoLLoLo',
    'oLllllLo',
    'oLLooLLo',
    '.oLwwLo.',
    '..oooo..',
  ],
  // Acid Scorpion: clearer pincers-body-curling-tail-with-stinger silhouette.
  scorpion: [
    '.e.....e.',
    'eEe...eEe',
    '.oe...eo.',
    '..oeeeo..',
    'e.oeeeo.e',
    '..oeeeo..',
    '..oeeoy..',
    '...oeEy..',
    '....oy...',
  ],
  // Stork (Berze Zeci): a little white bird with dark wingtips + an orange beak. White so
  // it can be tinted if ever needed; drawn upright.
  stork: [
    '.o....o.',
    '.ow..wo.',
    '..wwww..',
    '.wwwwwwa',
    '..wwww..',
    '..o..o..',
  ],
  // Musical note (Trans Mute silence burst + Spor Sayer shots): white so it tints to any
  // color at render time.
  note: [
    '..ww.',
    '..w.w',
    '..w..',
    '..w..',
    '.ww..',
    'www..',
    '.ww..',
  ],
  // Paper sheet (Files Below fire projectile): a lined page; tinted cream at render time.
  paper: [
    '.ooooo.',
    'owwwwwo',
    'okkkkwo',
    'owwwwwo',
    'okkkkwo',
    'owwwwwo',
    'okkkwwo',
    'owwwwwo',
    '.ooooo.',
  ],
};
